import React, { useEffect } from 'react'
import {useLocation} from 'react-router-dom';

const CapNavigation = () => {

const location=useLocation();
const {caseId}= location.state;
    useEffect(()=>{
        //clearRedux('logout');
    },[])

    return (
        <div align="center" style={{paddingTop:`2rem`}}>
        <h5>CaseId - {caseId} updated successfully.</h5>
        <h6>Please close the browser</h6> 
      </div>
)
}

export default CapNavigation;